export enum TextAnalysisTrackingEvent {
  SidebarOpened = `[Text Analysis] Sidebar Opened`,
  PromptSubmitted = `[Text Analysis] Prompt Submitted`,
  GroupsApplied = `[Text Analysis] Groups Applied`,
}
